//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "hub-geofence-row",

	props: {

		geofence: {
			required: true,
			type: Object
		}

	}

}

